<template>
    <div class="dax-search-formula" v-if="false" :class=" {'colour-fan-user' : (this.$parent.$parent.app_name != 'Dax')} ">
        <div class="profile-author">
            <div class="user-img">
                <avatar :src="'/storage/' + user.photo" :username="user.name" v-if="user.name"></avatar>
            </div>
            <div class="profile-author-name">
                <h3>{{ docName }}</h3>
                <p>{{  user.name }}</p>
            </div>
            <div class="dax-edited-btn">
                <a href="javascript:;" @click="cloneDoc()"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><g><g><path d="M6.23 14.308a2.538 2.538 0 0 1-2.538-2.539V5.077H2.407c-.565 0-1.022.457-1.022 1.022v8.44c0 1.147.93 2.076 2.077 2.076h8.44c.564 0 1.021-.457 1.021-1.022v-1.285zM6.23 0h9.232A2.538 2.538 0 0 1 18 2.538v9.231a2.538 2.538 0 0 1-2.538 2.539h-1.154v1.285A2.407 2.407 0 0 1 11.9 18h-8.44A3.462 3.462 0 0 1 0 14.538v-8.44a2.407 2.407 0 0 1 2.407-2.406h1.285V2.538A2.538 2.538 0 0 1 6.231 0zm0 1.385c-.636 0-1.153.516-1.153 1.153v9.231c0 .637.517 1.154 1.154 1.154h9.23c.638 0 1.154-.517 1.154-1.154V2.54c0-.638-.516-1.154-1.153-1.154z"></path></g></g></svg></a>
                <like-button :docId="this.$parent.$parent.documentData.id" :viewMode="'user-card'"></like-button>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from 'vue-avatar';
import LikeButton from "./LikeButton";

export default {
    name: "UserCard",
    components: {LikeButton, Avatar},
    data: function () {
        return {
            user: this.$parent.$parent.documentData.user,
            docName: this.$parent.$parent.documentData.name,
        };
    },
    methods: {
        likeDoc() {
            console.log('you liked ' + this.docName);
        },
        cloneDoc() {
            // this.$router.push({query: { clone: 'true' }})
            window.location.replace(this.$route.fullPath + '&clone=true');

            localStorage.setItem('clone_from', 'doc');
        },
    }
}
</script>

<style scoped>
.profile-author {
    padding: 16px 15px 15px 30px;
}
.dax-search-content .profile-author {
    padding-left: 0px !important;
}
</style>
